<template>
  <z-dialogo
    persistent
    ref="dialogo"
    titulo="Emissão Nota Fiscal de Serviço"
    largura="800px"
    altura="100px"
    dividers
    scrollable
    :loading="loading"
    @fechar="onFechar"
  >
    <template #conteudo>

      <div class="fill-height d-flex align-center justify-center">

          <h1 class="text-center text--primary">{{ mensagem }}</h1>

      </div>

      <!-- <v-row>
        <v-col sm="12">

          <v-alert :value="alert" color="error" icon="new_releases" class="mt-4">
            <div v-if="error.codigo"><b>Código Erro: </b> {{ error.codigo }}</div>
            <div v-if="error.mensagem"><b>Mensagem: </b> {{ error.mensagem }}</div>
            <div v-if="error.erro"><b>Erro: </b> {{ error.erro }}</div>
            <div v-if="error.correcao"><b>Correção: </b> {{ error.correcao }}</div>
          </v-alert>

        </v-col>
      </v-row> -->

    </template>

    <template #actions_right>
      <v-btn text @click="fechar" :disabled="loading">Fechar</v-btn>
      <v-btn color="primary" @click="emitirNFSE" :loading="loading">Emitir</v-btn>
      <v-btn v-if="!$config.IS_PRODUCTION" color="primary" @click="emitir" :loading="loading">EmitirLoop</v-btn>
      <v-btn v-if="!$config.IS_PRODUCTION" color="green" @click="consultarProtocolo(fatura.protocolo_emissao)" :loading="loading" :disabled="!fatura.protocolo_emissao">Consultar Protocolo</v-btn>
      <v-btn v-if="!$config.IS_PRODUCTION" color="pink" @click="consultarNFSe(fatura.protocolo_emissao)" :loading="loading" :disabled="!fatura.protocolo_emissao">Consultar NFSe</v-btn>
    </template>

  </z-dialogo>
</template>

<script>

import notaFiscaisApi from '@/app/services/notasfiscais.js'


export default {
  name: "ProcessoEmissaoDialog",

  props: ['nota'],

  data() {
    return {
      alert: false,
      loading: false,
      mensagem: '',
      etapas: [
        { descricao: 'Enviando nota fiscal' },
        { descricao: 'Consultando Protocolo' },
        { descricao: 'Consultando NFSe' },
      ],
      etapa_atual: 0,
      tentativas: 10,
      intervalo: 5000,
      situacao: 0,

      protocolo: null,

      error: {
        codigo: null,
        mensagem: null,
        erro: null,
        correcao: null
      }
    };
  },

  computed: {
    fatura() {
      return this.$store.state.notasfiscais.fatura;
    },
  },

  methods: {
    abrir() {
      this.mensagem = 'Clique no botão Emitir para enviar a nota fiscal.';
      this.$refs.dialogo.abrir();
      // this.emitirNFSE();
    },

    onFechar() {
      this.etapa_atual = 0;
      this.alert = false;
    },

    fechar() {
      this.onFechar();
      this.$refs.dialogo.fechar();
    },

    async emitir() {

      try {
        await this.emitirNFSE();

      } catch (error) {
        return false;
      }

      while (this.tentativas > 0) {

        console.log(this.tentativas);

        try {
          const response = await this.consultarProtocolo();
          if (response) {
            return false;
          }

        } catch (error) {
          throw error;
        }

        await new Promise(resolve => setTimeout(resolve, this.intervalo));
        this.tentativas--;
      }
      console.log("Terminou")


    },

    async emitirNFSE() {

      try {
        this.loading = true;
        this.alert = false;
        this.mensagem = 'Enviando a Nota Fiscal...'

        this.etapa_atual = 1;
        let response = await notaFiscaisApi.emitirNota(this.nota.id);
        if (response.protocolo) {

          this.protocolo = response.protocolo;
          this.etapa_atual = 0;

          // setTimeout(() => {
            this.mensagem = 'Protocolo Recebido.'
            // setTimeout(() => {
              this.loading = false;

              this.$router.push({
                name: 'NotasFiscaisLista', // 'FaturamentoLista',
              });
            // }, 2000);
          // }, 2000);

        }

      } catch (error) {
        this.loading = false;

        if (error.response) {
          const { data } = error.response;
          console.log({...data});

          if (data.error || data.message) {
            this.error.mensagem = data.message;
            this.error.erro = data.error;
          }

          if (data.codigo) {
            this.error.codigo   = data.codigo;
            this.error.mensagem = data.mensagem;
            this.error.correcao = data.correcao;
          }

          this.alert = true;
          this.etapa_atual = 0;

          this.mensagem = 'Houve um problema ao emitir a nota fiscal.'
        }

        throw error;

      }
    },


    async consultarProtocolo(protocolo) {
      try {
        this.zeraErros()
        this.loading = true;
        this.alert = false;

        this.etapa_atual = 2;
        const response = await notaFiscaisApi.consultarProtocolo(protocolo);

        if (response.situacao) {

          // this.etapa_atual = 0;

          if (response.situacao == 1) {
            this.error.mensagem = response.message;
            this.alert = true;
            return false;
          }

          if (response.situacao == 2) {
            return false;
          }

          if (response.situacao > 3) {
            await this.consultarNFSe(protocolo);
            return true;
          }

        }


      } catch (error) {

        console.log(error);

        if (error.response) {
          const { data } = error.response;
          console.log({...data});

          if (data.codigo) {
            this.error.codigo   = data.codigo;
            this.error.mensagem = data.mensagem;
            this.error.correcao = data.correcao;
            this.alert = true;
          }

          if (data.situacao == 3) {
            await this.consultarNFSe(protocolo);
          }

          this.etapa_atual = 0;

          throw error;
        }

      } finally {
        this.loading = false;
      }
    },

    async consultarNFSe(protocolo) {
      try {
        this.zeraErros()

        this.loading = true;

        this.etapa_atual = 3;
        const response = await notaFiscaisApi.consultarNota(protocolo);

        this.etapa_atual = 4;

        setTimeout(() => {
          this.$router.push({
            name: 'NotasFiscaisLista',
          })
        }, 1000);

      } catch (error) {

        console.log(error);
        if (error.response) {
          const { data } = error.response;
          console.log({...data});

          if (data.codigo) {
            this.error.codigo   = data.codigo;
            this.error.mensagem = data.mensagem;
            this.error.correcao = data.correcao;
            this.alert = true;
          }
        }

        this.etapa_atual = 0;
      } finally {
        this.loading = false;
      }
    },


    zeraErros() {
      this.alert = false;
      this.error = {
        codigo: null,
        mensagem: null,
        erro: null,
        correcao: null
      }
    }

  },
};
</script>

<style lang="scss" scoped></style>
